import { isEmpty, isNil } from 'ramda';

const isBlank = (item) => isEmpty(item) || isNil(item);

export { isBlank };
